module.exports = __webpack_public_path__ + "static/media/full-cart.57a3f41c.svg";